import { paths } from 'paths';
import type { NavItemConfig } from 'types/nav';

export const navItems = [
  { key: 'frameworks', title: 'Frameworks', href: paths.app.admin.frameworks.home, icon: 'framework' },
  { key: 'organisations', title: 'Organisations', href: paths.app.admin.organisations.home, icon: 'organisations' },
  { key: 'users', title: 'Users', href: paths.app.admin.users.home, icon: 'users' },
] satisfies NavItemConfig[];
